/**
 * Shared copy for the discussion-package.
 */
import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

import type {FeedbackType, TabsData} from "./types.ts";

export const getTabsStrings: () => Partial<Record<FeedbackType, TabsData>> =
    memoize(
        (): Partial<Record<FeedbackType, TabsData>> => ({
            projecthelp: {
                key: "projecthelp",
                label: t`Help Requests`,
                buttonContents: t`Request help`,
                tipLabel: t`Request help from your peers`,
                tipContents: t`Please describe your problem or question in detail. The better you describe it, the more likely you are to get a great response. Make sure you've checked the documentation first!`,
                listTabsLabel: t`Help requests`,
                placeholder: t`Request help...`,
                textAreaLabel: t`Help request`,
            },
            questions: {
                key: "questions",
                label: t`Questions`,
                buttonContents: t`Ask question`,
                tipLabel: t`Tip for a good question`,
                tipContents: t`Be specific, and add a timestamp or section. Example: “At 5:31, how is the moon large enough to block the sun? Isn't the sun way larger than the moon?”`,
                listTabsLabel: t`Questions`,
                placeholder: t`Ask a question...`,
                textAreaLabel: t`Question`,
            },
            comments: {
                key: "comments",
                label: t`Tips & Thanks`,
                buttonContents: t`Post tip or thanks`,
                tipLabel: t`Post a tip or thank the author`,
                tipContents: t`Share a tip, or offer positive feedback that lets the creator know what is working well.`,
                listTabsLabel: t`Tips & Thanks`,
                placeholder: t`Post a tip or thanks...`,
                textAreaLabel: t`Tip or Thanks`,
            },
            clarifications: {
                key: "clarifications",
                label: t`Mistakes`,
                buttonContents: t`Report mistake`,
                tipLabel: t`If you spot an error in the content, report it here`,
                tipContents: t`Example: “At 2:33, Sal said "single bonds" but meant covalent bonds.”`,
                listTabsLabel: t`Mistakes`,
                placeholder: t`Report a mistake...`,
                textAreaLabel: t`Mistake`,
            },
        }),
    );
